// extracted by mini-css-extract-plugin
export var heroImage = "_bv-1";
export var modal = "_bv-0";